import styled from 'styled-components';

import { Button } from '@thinknet-gmbh/platform-common-ui';

export const TaskTemplateWrapper = styled.div`
  display: flex;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const TaskTemplateTitle = styled.div`
  white-space: nowrap;
  margin-right: 8px;
  font-weight: 600;
  color: #42526e;
`;

export const TaskNamesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const TaskName = styled.div`
  margin-right: 5px;
`;

export const IconContainer = styled.div`
  margin-left: 5px;
  div {
    cursor: pointer;
  }
`;

export const TemplateTasksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
`;

export const DeleteContainer = styled.div`
  display: flex;
  width: 100%;

  & > div:first-child {
    width: 100% !important;
    margin: 0px !important;
  }

  & > div:last-child {
    width: auto;
    align-self: flex-start;
    cursor: pointer;
    margin: 33px 0 0 10px;
  }
`;

export const AddButton = styled(Button)`
  align-self: flex-end;
`;
